/* eslint-disable prettier/prettier */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import P from 'prop-types';
import { Modal } from '../Modal';
import { toast } from 'react-toastify';
import { Tabs } from '../Tabs';
import useWindowDimensions, {
  ArredondaValores,
  Capitalize,
  ClearPedido,
  FormataValor,
  GetAllItensSacola,
  GetSacola,
  GetStatusLoja,
  SaveUser,
  generateAvailableTimes,
  isObjectEmpty,
} from '../../utils/utils';
import { ValoresTotais } from '../ValoresTotais';
import { FormasPagamento } from '../FormasPagamento';
import { GlobalContext } from '../../contexts/HomeContext';
import { FinalizacaoRodape } from '../FinalizacaoRodape';
import { EnviaPedido, GeraNumeroPedido, GetCartoes, Logar, RealizaPagamentoAutoAtendimento } from '../../utils/api/api';
import { CadastroCartoes } from '../PagamentoOnline/CadastroCartoes';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt-BR';
import { addDays, getDay, format, isSameDay } from 'date-fns';
import '../../styles/react-datepicker.css';
import Stripe from '../PagamentoOnline/Stripe/Stripe';
import { useSocketio } from '../../contexts/SocketioContext';
import { useNavigate } from 'react-router';
import CardSelectOptions from '../CardSelectOptions';
import GatewaysLogo from '../../img/Gateways/GatewaysLogo';
import { trackGAEvent, trackMetaPixelEvent } from '../../utils/tracking';

registerLocale('pt-BR', pt);
setDefaultLocale('pt-BR');

export const Finalizacao = ({ closeModal, param }) => {
  const { setDadosApp, dadosApp, user, setUser, setEnderecos, setSacola, setOpenPedidos, statusLoja, setStatusLoja, enderecos } =
    useContext(GlobalContext);

  const [modalCartoes, setModalCartoes] = useState('none');
  const [modalEnderecos, setModalEnderecos] = useState('none');
  const [modalCadastro, setModalCadastro] = useState(false);
  const [modalLogin, setModalLogin] = useState(false);
  const [modalLoading, setModalLoading] = useState(dadosApp.Empresa.Config.pagamento_online == 1 ? 'block' : 'none'); // none
  const [modalTroco, setModalTroco] = useState('none');

  const [tabEntregaActive, setTabEntregaActive] = useState(
    dadosApp.IdLoja === 9130 ? 1 : dadosApp.IdLoja === 1910 ? 1 : 0,
  ); // cliente do sergio

  const formasPagamentoHabilitadas = {
    online: dadosApp.Empresa.Config.pagamento_online === 1,
    stripe: !!dadosApp.Empresa.Config.stripe_token_secreto,
    debito: dadosApp.Empresa.Config.debito_habilitado === 1,
    pix: dadosApp.Empresa.Config.pix_habilitado === 1,
  };

  const hasPagamentoDisponivel = Object.values(formasPagamentoHabilitadas).some(Boolean);

  const [tabPagamentoActive, setTabPagamentoActive] = useState(hasPagamentoDisponivel ? 0 : 1);
  // const [tabPagamentoActive, setTabPagamentoActive] = useState(
  //   dadosApp.Empresa.Config.pagamento_online === 1 ? 0
  //     : dadosApp.Empresa.Config.stripe_token_secreto?.length > 0 ? 0
  //       : dadosApp.Empresa.Config.debito_habilitado === 1 ? 0
  //         : dadosApp.Empresa.Config.pix_habilitado === 1 ? 0
  //           : 1);
  const [enderecoEntrega, setEnderecoEntrega] = useState(enderecos?.length > 0 ? enderecos?.filter((p) => p.titulo !== "FATURA").length === 1 ? enderecos?.filter((p) => p.titulo !== "FATURA").slice(0, 1)[0] : {} : []);
  const [cartaoValidado, setCartaoValidado] = useState(false);
  const [pagOnlineSelecionado, setPagOnlineSelecionado] = useState({});
  const [pagSelecionado, setPagSelecionado] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);
  //const [temCartaoCadastrado, setTemCartaoCadastrado] = useState(false);
  const [listOpcoesPagOnline, setListOpcoesPagOnline] = useState([]);
  const [opcaoCartaoPagOnline, setOpcaoCartaoPagOnline] = useState('');
  const [troco, setTroco] = useState(0);
  const { width } = useWindowDimensions();
  const pagEntregaText = width < 340 ? 'Pgto. na Entrega' : 'Pagar na Entrega';
  let obj = param.conferencia ? param.conferencia : GetSacola(dadosApp, enderecoEntrega);
  const cartaoPreSelecionado = useRef(null);
  const [startDate, setStartDate] = useState(statusLoja.NextValidDay); // addMinutes(new Date(), dadosApp.Empresa.Config.previsao_entrega)
  const [time, setTime] = useState([]);
  const [entregaProgramada, setEntregaProgramada] = useState(dadosApp.IdLoja === 9130 ? true : dadosApp.IdLoja === 1910 ? true : !statusLoja.StatusLoja);
  const [exclude, setExclude] = useState([]);
  const { socketResponse, socketEmit } = useSocketio();

  const showCadastreSe = (user.id > 0 && user.email.includes("pedido_") && dadosApp.aceitaPagamentoSemUsuario && opcaoCartaoPagOnline === "novo_cartao")
    || (opcaoCartaoPagOnline === "novo_cartao" && user.id === 0) || (opcaoCartaoPagOnline === "" && user.id === 0) || (opcaoCartaoPagOnline === "debito" && user.id === 0);

  const showFormCartao = listOpcoesPagOnline.length > 0 && opcaoCartaoPagOnline === 'novo_cartao' && user.id > 0
    || listOpcoesPagOnline.length > 0 && opcaoCartaoPagOnline === 'debito' && user.id > 0
    || listOpcoesPagOnline.length > 0 && opcaoCartaoPagOnline === 'novo_cartao' && user.id > 0 && !user.email.includes("pedido_") && !dadosApp.aceitaPagamentoSemUsuario
    || listOpcoesPagOnline.length === 0 && opcaoCartaoPagOnline === 'novo_cartao' && user.id > 0;

  const showButtonFinalizar = (opcaoCartaoPagOnline !== 'novo_cartao' && opcaoCartaoPagOnline !== "" && opcaoCartaoPagOnline !== "debito" && user.id > 0)
    || (opcaoCartaoPagOnline === "pix" && dadosApp.aceitaPagamentoSemUsuario);




  const navigate = useNavigate();
  let isGettingCards = useRef(false);

  const dadosCartao = useMemo(() => {
    return {
      cliente: {
        codigo: user.id,
        nome: user.nome,
        sobrenome: user.sobrenome,
        nomeCompleto: user.nome_completo,
        email: user.email,
        tipoDocumento: 'CPF',
        numeroDocumento: user.cpf,
        ddd: user.telefone_ddd,
        telefone: user.telefone,
      },
      cartao: {
        numeroCartao: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.cartao_numero : '',
        nomeImpresso: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.nome_completo_cartao : '',
        mesExpiracao: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.cartao_validade.substring(0, 2) : '',
        anoExpiracao: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.cartao_validade.substring(3, 8) : '',
        codigoSeguranca: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.cartao_codigo_seguranca : '',
        cpf: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.cpf : '',
        tokenCard: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.tokenCard : '',
        salvar_cartao: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.salvar_cartao : false,
        metodo_pagamento: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado.metodo_pagamento : 0,
      },
      empresa: {
        idLoja: dadosApp.IdLoja,
        fantasia: dadosApp.Empresa.Empresa.fantasia,
        razaoSocial: dadosApp.Empresa.Empresa.razao,
      },
      // COMENTEI O ENDEREÇO POIS NA NOVA VERSÃO DA API DA PAGSEGURO NÃO ESTA MAIS LENDO
      endereco: {
        cep: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.cep : '',
        endereco: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.endereco : '',
        endereco_numero: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.endereco_numero : '',
        endereco_complemento: !isObjectEmpty(pagOnlineSelecionado)
          ? pagOnlineSelecionado?.endereco?.endereco_complemento
          : '',
        endereco_bairro: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.endereco_bairro : '',
        endereco_cidade: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.endereco_cidade : '',
        endereco_estado: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.endereco_estado : '',
        endereco_pais: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.endereco_pais : '', //'BRASIL',
        uf: !isObjectEmpty(pagOnlineSelecionado) ? pagOnlineSelecionado?.endereco?.uf : '',
      },
    };
  }, [user, dadosApp, pagOnlineSelecionado]);


  if (tabEntregaActive == 1) {
    obj.taxa = 0;
    obj.total = obj.subtotal;
  }

  // cria o obj pagamento
  const pag = useMemo(() => {
    const payment = [];
    if (tabPagamentoActive === 0) {
      // PAGAMENTO ONLINE
      payment.push({ // se for pix colocar descricao PIX
        descricao: opcaoCartaoPagOnline === "pix" ? "PIX" : pagOnlineSelecionado.cartao_nome === '' ? 'PAGAMENTO ONLINE' : pagOnlineSelecionado.cartao_nome,
        valor: tabEntregaActive === 0 ? obj.total : obj.subtotal,
        tipo: opcaoCartaoPagOnline === "pix" ? 'DEBITO' : opcaoCartaoPagOnline === "debito" ? 'DEBITO' : 'CREDITO',
        pago_online: opcaoCartaoPagOnline === "pix" ? 0 : 1,
      });
    } else {
      payment.push({
        descricao: pagSelecionado.descricao,
        valor: pagSelecionado.especie === 'ESPECIE' && troco > obj.total ? troco : obj.total,
        tipo: pagSelecionado.especie,
        pago_online: 0,
      });
    }

    return payment;
  }, [tabPagamentoActive, pagOnlineSelecionado, pagSelecionado, troco, obj.total, obj.subtotal, opcaoCartaoPagOnline, tabEntregaActive]);

  const createObjDados = useCallback(
    (user, tabEntregaActive, enderecoEntrega, troco, pag) => {
      return {
        Cliente: {
          codigo_cliente: user.id,
          nome_cliente: user.nome_completo,
          ddd: user.telefone_ddd,
          telefone: user.telefone,
          retirada_balcao: tabEntregaActive,
          cep: enderecoEntrega.cep,
          endereco: enderecoEntrega.endereco,
          endereco_numero: enderecoEntrega.endereco_numero,
          complemento_endereco: enderecoEntrega.endereco_complemento,
          bairro: enderecoEntrega.endereco_bairro,
          cidade: enderecoEntrega.endereco_cidade,
          uf: enderecoEntrega.endereco_estado,
          cliente_email: user.email ? user.email : '',
          cpf_cnpj: user.cpf ? user.cpf : '',
          cliente_latitude: enderecoEntrega.latitude,
          cliente_longitude: enderecoEntrega.longitude,
        },
        Pagamento: pag,
        TaxaEntrega: tabEntregaActive === 0 ? obj.taxa : 0,
        Troco: troco,
      };
    },
    [obj.taxa],
  );




  const dados = useMemo(
    () => createObjDados(user, tabEntregaActive, enderecoEntrega, troco, pag),
    [createObjDados, user, tabEntregaActive, enderecoEntrega, troco, pag],
  );


  const showHideModalLoading = useCallback(() => {
    setModalLoading(modalLoading == 'none' ? 'block' : 'none');
  }, [modalLoading]);

  const showHideModalTroco = useCallback(() => {
    setModalTroco(modalTroco == 'none' ? 'block' : 'none');
  }, [modalTroco]);

  const showHideModalEnderecos = useCallback(() => {
    setModalEnderecos(modalEnderecos == 'none' ? 'block' : 'none');
  }, [modalEnderecos]);

  const showHideModalCartoes = useCallback(() => {
    setModalCartoes(modalCartoes == 'none' ? 'block' : 'none');
  }, [modalCartoes]);

  const createProdutoEnvio = useCallback((_produto, _montagem = [], _obrigatorios = [], _adicionais = []) => {
    return {
      id: _produto.id,
      codigo_produto: _produto.codigo_produto,
      descricao_produto: _produto.descricao_produto,
      observacao_pedido: _produto.observacao_pedido,
      valor_unitario: _produto.valor_unitario,
      quantidade: _produto.quantidade,
      quantidade_texto: _produto.quantidade_texto,
      subtotal: _produto.subtotal,
      desconto: _produto.desconto,
      acrescimo: _produto.acrescimo,
      total: _produto.total,
      servico: 0,
      total_com_servico: _produto.total_com_servico,
      importado: opcaoCartaoPagOnline === "pix" && tabPagamentoActive === 0 ? 99 : 0,
      Montagem: _montagem,
      Obrigatorios: _obrigatorios,
      Adicionais: _adicionais,
    };
  }, [opcaoCartaoPagOnline, tabPagamentoActive]);




  const enderecoConcatenado = useCallback(() => {
    if (enderecoEntrega.length === 0) return "Selecionar Endereço";
    if (enderecoEntrega?.endereco_complemento != '') {
      return Capitalize(
        enderecoEntrega?.endereco + ', ' + enderecoEntrega?.endereco_numero + ', ' + enderecoEntrega?.endereco_complemento,
      );
    } else {
      return Capitalize(enderecoEntrega?.endereco + ', ' + enderecoEntrega?.endereco_numero);
    }
  }, [enderecoEntrega]);

  const preparaDadosPedido = useCallback(
    async (dados, idloja, closeModal) => {
      const pedidos = GetAllItensSacola(idloja);
      if (pedidos?.length <= 0) {
        toast.error('Não foi possivel selecionar os itens da sacola', { containerId: 'modalToast' });
        closeModal();
        return false;
      }

      const nPedido = await GeraNumeroPedido();
      if (nPedido.status != 200) {
        toast.error('Erro ao gerar o número do pedido', { containerId: 'modalToast' });
        return false;
      }

      let subtotal = 0;
      let desconto = 0;
      let acrescimo = 0;

      let whatsapp =
        '****** Nº Pedido: ' +
        nPedido.data +
        ' ******%0a*Cliente: ' +
        Capitalize(dados.Cliente.nome_cliente) +
        '*%0a' +
        'Tel: ' +
        dados.Cliente.ddd +
        dados.Cliente.telefone +
        '%0a' +
        dados.Cliente.cliente_email +
        '%0a';

      if (dados.Cliente.cpf_cnpj !== '') {
        whatsapp +=
          'CPF/CNPJ: ' +
          dados.Cliente.cpf_cnpj + //
          '%0a';
      }

      if (dados.Cliente.retirada_balcao === 0) {
        whatsapp +=
          '%0a****** Endereço de Entrega ******%0a' +
          enderecoConcatenado() +
          ', ' +
          dados.Cliente.bairro +
          ', ' +
          dados.Cliente.cidade +
          ' - ' +
          dados.Cliente.uf +
          '%0aCEP: ' +
          dados.Cliente.cep +
          '%0a';
      } else {
        whatsapp += '****** Cliente ira retirar o pedido ******%0a';
      }

      whatsapp += '%0a****** Pagamento ******%0a';
      if (dados.Pagamento[0].pago_online === 1) {
        whatsapp += 'Pago Online: ' + dados.Pagamento[0].descricao + '%0a';
      } else {
        if (dados.Pagamento[0].tipo === 'ESPECIE') {
          whatsapp += dados.Pagamento[0].descricao + '%0a';
          if (dados.Troco > 0) {
            whatsapp += 'Troco: ' + FormataValor(dados.Troco) + '%0a';
          }
        } else {
          whatsapp += dados.Pagamento[0].descricao + ': Levar Máquininha%0a';
        }
      }

      const envio = {
        idloja: idloja,
        mesa: pedidos[0].mesa,
        numero_mesa: pedidos[0].numero_mesa,
        posicao: pedidos[0].posicao,
        modulo: pedidos[0].modulo,
        local_pedido: pedidos[0].local_pedido,
        tipo_app: dadosApp.TipoApp, //dadosApp.Empresa.Empresa.tipo_app,
        //tipo_app: tabEntregaActive === 1 ? 'BALCAO' : dadosApp.TipoApp, //dadosApp.Empresa.Empresa.tipo_app,
        retirada_balcao: tabEntregaActive,
        nome_app: 'GW MOBILE',
        Chave: 'P9X2X5Z8',
        numero_pedido: nPedido.data,
        Cliente: dados.Cliente,
        Produtos: pedidos
          .filter(
            ({ montagem_id, obrigatorio_id, adicionais_id }) =>
              montagem_id == 0 && obrigatorio_id == 0 && adicionais_id == 0,
          )
          .map((_produto) => {
            const _montagemEnvio = [];
            const _obrigatoriosEnvio = [];
            const _adicionaisEnvio = [];

            if (_produto.tipoPizza == 'FRACAO') {
              _produto.quantidade = _produto.quantidade_fracionada;
              _produto.valor_unitario = _produto.preco_pizza;
            }

            let _desc = _produto.quantidade_texto + 'x ' + Capitalize(_produto.descricao_produto);
            if (_produto.tipo_produto === 'PIZZA') {
              _desc = _produto.quantidade_texto + ' ' + Capitalize(_produto.descricao_produto);
            }
            whatsapp += '%0a****** ' + _desc + ' ******%0a';

            // MONTAGEM
            pedidos
              .filter((m) => m.montagem_id == _produto.id)
              .map((montagem) => {
                if (montagem.tipoPizza == 'FRACAO') {
                  montagem.quantidade = montagem.quantidade_fracionada;
                  montagem.valor_unitario = montagem.preco_pizza;
                }
                if (_produto.tipo_produto == 'COMBO') montagem.valor_unitario = 0;
                else subtotal += montagem.subtotal;

                whatsapp += '  >  ' + montagem.quantidade_texto + 'x ' + Capitalize(montagem.descricao_produto) + '%0a';

                _montagemEnvio.push(createProdutoEnvio(montagem));
              });

            // OBRIGATÓRIOS
            pedidos
              .filter((o) => o.obrigatorio_id == _produto.id)
              .map((obrigatorios) => {
                subtotal += obrigatorios.subtotal;

                whatsapp +=
                  '  >  ' + obrigatorios.quantidade_texto + 'x ' + Capitalize(obrigatorios.descricao_produto) + '%0a';

                _obrigatoriosEnvio.push(createProdutoEnvio(obrigatorios));
              });

            // ADICIONAIS
            pedidos
              .filter((a) => a.adicionais_id == _produto.id)
              .map((adicionais) => {
                subtotal += adicionais.subtotal;

                whatsapp +=
                  '  >  ' + adicionais.quantidade_texto + 'x ' + Capitalize(adicionais.descricao_produto) + '%0a';

                _adicionaisEnvio.push(createProdutoEnvio(adicionais));
              });

            subtotal += _produto.subtotal;

            if (_produto.observacao_pedido !== '') {
              whatsapp += 'Obs.: ' + _produto.observacao_pedido + '%0a';
            }

            return { ...createProdutoEnvio(_produto, _montagemEnvio, _obrigatoriosEnvio, _adicionaisEnvio) };
          }),
        Pagamento: dados.Pagamento,
        Taxa: dados.TaxaEntrega,
        previsao_entrega: dadosApp.Empresa.Config.previsao_entrega,
      };

      // SE ESTIVER CONFIGURADO PARA ENVIAR O PEDIDO VIA WHATSAPP
      if (dadosApp.Empresa.Config.whatsapp === 1) {
        const phone = dadosApp.Empresa.Config.ddd + dadosApp.Empresa.Config.telefone;
        //envio.whatsapp = 'whatsapp:/ / send ? text = ' + whatsapp + ' & phone=55' + phone;
        envio.whatsapp = 'https://api.whatsapp.com/send?text=' + whatsapp + '&phone=55' + phone;
      }

      envio.Subtotal = ArredondaValores(subtotal, 2);
      envio.Desconto = ArredondaValores(desconto, 2);
      envio.Acrescimo = ArredondaValores(acrescimo, 2);
      envio.Total = ArredondaValores(subtotal - desconto + acrescimo, 2);
      envio.Troco = dados.Troco;
      envio.total_com_taxa = ArredondaValores(envio.Total + envio.Taxa, 2);

      if (tabPagamentoActive === 0) {
        envio.pagamento_online = {
          //operadora: dadosApp.Empresa.Config.cartao_operadora,
          operadora: opcaoCartaoPagOnline?.toUpperCase() === "PIX" ? dadosApp.Empresa.Config.pix_operadora : dadosApp.Empresa.Config.cartao_operadora,
          valor: envio.total_com_taxa,
          qtdParcelas: 0,
          cliente: dadosCartao.cliente,
          endereco: dadosCartao.endereco,
          enderecosEntrega: [{}],
          cartao: dadosCartao.cartao,
          empresa: dadosCartao.empresa,
          guidSessao: dadosApp.GuidSessao,
          tid: dadosApp.sH,
          metodo_pagamento: dadosCartao.cartao.metodo_pagamento
        };
        envio.metodo_pagamento = dadosCartao.cartao.metodo_pagamento;
      }

      // se tiver com agendamento configurado e houve agendamento
      //envio.agendamento = dadosApp.IdLoja === 9130 ? true : dadosApp.IdLoja === 1910 ? true : entregaProgramada;
      envio.agendamento = entregaProgramada;
      if (dadosApp.Empresa.Config.agendamento === 1) {
        envio.agendamento_datahora = format(startDate, 'yyyy-MM-dd HH:mm:ss');
      }

      if (dados.Pagamento[0].tipo == 'ESPECIE') envio.total_recebido = ArredondaValores(envio.Troco, 2);
      else envio.total_recebido = envio.total_com_taxa;
      return envio;
    },
    [
      dadosApp,
      createProdutoEnvio,
      tabPagamentoActive,
      dadosCartao,
      enderecoConcatenado,
      tabEntregaActive,
      entregaProgramada,
      startDate,
      opcaoCartaoPagOnline
    ],
  );


  // da baixa na mesa/cartao on caixa PDV
  const handleBaixaAutoAtendimento = useCallback(
    async (tid = '') => {
      let _qs = { ...dadosApp.Qs };

      _qs.Solicitacao = '5';
      _qs.numero_mesa = dadosApp.Qs.comanda === 0 ? _qs.mesa : dadosApp.Qs.comanda; // testar lendo QRCode e "nao tem comanda";
      _qs.tid = tid; // tid
      _qs.cpf = user.cpf;

      _qs.Body = JSON.stringify(_qs);

      socketEmit(_qs);
    },
    [dadosApp, socketEmit, user],
  );


  const preparaDadosPagamentoAutoAtendimento = useCallback(
    async (dados, idloja, closeModal) => {
      const pedidos = param.conferencia;
      if (pedidos?.length <= 0) {
        toast.error('Não foi possivel selecionar os itens do pedido', { containerId: 'modalToast' });
        closeModal();
        return false;
      }

      const nPedido = await GeraNumeroPedido();
      if (nPedido.status != 200) {
        toast.error('Erro ao gerar o número do pedido', { containerId: 'modalToast' });
        return false;
      }

      const envio = {};
      envio.Taxa = ArredondaValores(param.conferencia?.taxa, 2);
      envio.Subtotal = ArredondaValores(param.conferencia?.subtotal, 2);
      envio.Desconto = ArredondaValores(param.conferencia?.desconto, 2);
      envio.Acrescimo = ArredondaValores(param.conferencia?.acrescimo, 2);
      envio.Total = ArredondaValores(param.conferencia?.subtotal - envio.Desconto + envio.Acrescimo, 2);
      envio.Troco = 0;
      envio.total_com_taxa = ArredondaValores(envio.Total + envio.Taxa, 2);
      envio.Cliente = dados.Cliente;
      envio.Pagamento = dados.Pagamento;
      envio.anoExpiracao = parseInt(dadosCartao.cartao.anoExpiracao);
      envio.mesExpiracao = parseInt(dadosCartao.cartao.mesExpiracao);
      envio.pagamento_online = {
        //operadora: dadosApp.Empresa.Config.cartao_operadora,
        operadora: opcaoCartaoPagOnline?.toUpperCase() === "PIX" ? dadosApp.Empresa.Config.pix_operadora : dadosApp.Empresa.Config.cartao_operadora,
        valor: envio.total_com_taxa,
        qtdParcelas: 0,
        cliente: dadosCartao.cliente,
        endereco: dadosCartao.endereco,
        enderecosEntrega: [{}],
        cartao: dadosCartao.cartao,
        empresa: dadosCartao.empresa,
        guidSessao: dadosApp.GuidSessao,
        tid: dadosApp.sH,
        isAutoAtendimento: true,
      };

      return envio;
    },
    [dadosApp, dadosCartao, param.conferencia, opcaoCartaoPagOnline],
  );

  const handleIsCompleted = useCallback(
    (showMsg = false, isStripe = false) => {
      // ENTREGA
      if (tabEntregaActive === 0 && dadosApp.TipoApp === 'DELIVERY') {
        if (isObjectEmpty(enderecoEntrega)) {
          setIsCompleted(false);
          if (showMsg) toast.error('Informe o endereço de entrega');
          return false;
        }
      }

      // PAG. ONLINE
      if (tabPagamentoActive === 0 && !isStripe) {
        if (isObjectEmpty(pagOnlineSelecionado)) {
          setIsCompleted(false);
          if (showMsg) toast.error('Escolha uma forma de pagamento.');
          return false;
        }
      }

      // PIX VALIDA SE O CPF É VÁLIDO
      if (!dadosApp.aceitaPagamentoSemUsuario && tabPagamentoActive === 0 && opcaoCartaoPagOnline === "pix" && user.id === 0
        || tabPagamentoActive === 0 && opcaoCartaoPagOnline === "novo_cartao" && user.id === 0) {
        setIsCompleted(false);
        if (showMsg) toast.error(opcaoCartaoPagOnline === "pix" ? 'Cadastre-se para pagar com PIX' : "Cadastre-se para pagar com Cartão");
        return false;
      }

      // PIX VALIDA SE O CPF É VÁLIDO
      //if (tabPagamentoActive === 0 && opcaoCartaoPagOnline === "pix" && user.cpf === "") {

      // OBRIGA O CPF CASO O CLIENTE TENTE REALIZA O PAGAMENTO ONLINE
      if (tabPagamentoActive === 0 && user.cpf === "" && !dadosApp.aceitaPagamentoSemUsuario) {
        setIsCompleted(false);
        if (showMsg) toast.error('CPF Inválido! Complete seu Cadastro.');
        return false;
      }

      // PAG. NA ENTREGA
      if (tabPagamentoActive === 1) {
        if (isObjectEmpty(pagSelecionado)) {
          setIsCompleted(false);
          if (showMsg) toast.error('Escolha uma forma de pagamento');
          return false;
        }
      }
      setIsCompleted(true);
      return true;
    },
    [dadosApp.aceitaPagamentoSemUsuario, enderecoEntrega, tabEntregaActive, pagSelecionado, tabPagamentoActive, pagOnlineSelecionado, dadosApp.TipoApp, user.cpf, user.id, opcaoCartaoPagOnline],
  );

  const fechaModals = useCallback(() => {
    closeModal();
    {
      param.closeModal != undefined && param.closeModal();
    }
    ClearPedido(dadosApp.IdLoja, setSacola);
    setOpenPedidos('block|true');
  }, [param, dadosApp.IdLoja, setSacola, closeModal, setOpenPedidos]);

  const handleCartaoValidado = () => {
    setCartaoValidado(true);
  };


  // SE FOR PAGAMENTO DE MESA OU CARTAO DO AUTO ATENDIMENTO
  const handlePagarAutoAtendimento = useCallback(
    async (e, isValidation = false, paydAsAppleOrGoogle = false, nsu = '') => {
      if (tabPagamentoActive == 1) e.preventDefault();

      if (paydAsAppleOrGoogle) {
        handleBaixaAutoAtendimento(nsu); // chama api pdv pelo socket
        return;
      }

      if (!handleIsCompleted(true, isValidation)) {
        setModalLoading('none');
        return false;
      }

      if (isValidation) return true; // teste stripe

      showHideModalLoading();

      // if (paydAsAppleOrGoogle) {
      //   handleBaixaAutoAtendimento(nsu); // chama api pdv pelo socket
      //   return;
      // }

      const envio = await preparaDadosPagamentoAutoAtendimento(dados, dadosApp.IdLoja, closeModal);
      if (envio) {
        const resp = await RealizaPagamentoAutoAtendimento(envio);

        if (resp.data.status == 0) {
          handleBaixaAutoAtendimento(resp.data.msg); // chama api pdv pelo socket passando o TID do retorno

          // // pega a resposta da apiPDV e entao diz se deu problema pra dar baixa na mesa
          // // diz que pagou mas nao conseguiu dar baixa na mesa

          // toast.success('Pagamento Realizado com sucesso', { containerId: 'modalToast' });
          // fechaModals();

          if (dadosApp.Empresa.Config.cartao_operadora === 'PAGSEGURO') {
            setDadosApp((prevState) => {
              return {
                ...prevState,
                GuidSessao: resp.data.guid,
              };
            });
          }
        } else {
          setModalLoading('none');
          //handleBaixaAutoAtendimento(); // chama api pdv pelo socket
          toast.error(resp.data.msg, { containerId: 'modalToast', autoClose: 4500 });
          if (isValidation) return false;
        }
      } else setModalLoading('none');
    },
    [
      handleIsCompleted,
      tabPagamentoActive,
      showHideModalLoading,
      closeModal,
      dados,
      dadosApp,
      setDadosApp,
      preparaDadosPagamentoAutoAtendimento,
      handleBaixaAutoAtendimento,
    ],
  );

  const handleAutoLogin = useCallback(
    async (usuario) => {
      const response = await Logar(usuario);
      if (response.data.Retorno.status == 0) {
        usuario.id = response.data.Usuario.id;
        usuario.nome = response.data.Usuario.nome;
        usuario.sobrenome = response.data.Usuario.sobrenome;
        usuario.nome_completo = response.data.Usuario.nome_completo;
        usuario.ativo = response.data.Usuario.ativo;
        usuario.cpf = response.data.Usuario.cpf;
        usuario.telefone_ddd = response.data.Usuario.telefone_ddd;
        usuario.telefone = response.data.Usuario.telefone;
        usuario.sexo = response.data.Usuario.sexo;
        SaveUser(usuario.idloja, usuario, setUser);
        setEnderecos(response.data.Enderecos);
      }
    },
    [setEnderecos, setUser],
  );

  const trackPurchase = (envio) => {
    const totalValue = parseFloat(envio?.total_com_taxa || envio?.total || 0);
    const produtos = Array.isArray(envio?.Produtos) ? envio.Produtos : [];

    const contents = produtos.map((item) => ({
      id: item.codigo_produto?.toString(),
      quantity: item.quantidade || 1,
      item_price: parseFloat(item.valor_unitario || 0),
    }));

    const contentIds = produtos.map((item) => item.codigo_produto?.toString());

    const numItems = produtos.reduce((acc, item) => acc + (item.quantidade || 0), 0);

    trackMetaPixelEvent('Purchase', {
      value: totalValue,
      currency: 'BRL',
      content_type: 'product',
      content_ids: contentIds,
      contents: contents,
      num_items: numItems,
    });

    trackGAEvent('Ecommerce', 'Purchase', 'Pedido', totalValue);
  };

  const handleFinalizar = useCallback(
    async (e, isValidation = false, paydAsAppleOrGoogle = false, nsu = '') => {
      if (tabPagamentoActive == 1) e.preventDefault();

      if (!paydAsAppleOrGoogle) {
        if (!handleIsCompleted(true, isValidation)) {
          setModalLoading('none');
          return false;
        }
      }

      showHideModalLoading();

      const aberta = await GetStatusLoja(dadosApp, statusLoja, setStatusLoja); //if (!GetStatusLoja(dadosApp, statusLoja, setStatusLoja)) {

      if (!aberta && dadosApp?.Empresa?.Config?.agendamento === 0) {
        toast.error('Loja Fechada', { autoClose: 2500 });
        setModalLoading('none');
        return false;
      }

      const envio = await preparaDadosPedido(dados, dadosApp.IdLoja, closeModal);


      if (paydAsAppleOrGoogle) {
        envio.Pagamento[0].descricao = 'PAGAMENTO ONLINE STRIPE';
        envio.pagamento_online = {
          operadora: 'STRIPE',
          valor: envio.total_com_taxa,
          qtdParcelas: 0,
          cliente: {},
          endereco: {},
          enderecosEntrega: [{}],
          cartao: {},
          empresa: dadosCartao.empresa,
          guidSessao: dadosApp.GuidSessao,
          tid: nsu,
        };

      }

      if (envio) {
        envio.isValidation = isValidation;
        const resp = await EnviaPedido(envio);

        setModalLoading('none');

        if (resp.data.status == 0) {
          if (isValidation) return true;

          // CASO SEJA PAGAMENTO ApplePay/GooglePay/Pix VIA AUTO ATENDIMENTO BALCAO
          // E SEM USUARIO CADASTRADO
          if (dadosApp.aceitaPagamentoSemUsuario && user.id === 0 && paydAsAppleOrGoogle
            || dadosApp.aceitaPagamentoSemUsuario && opcaoCartaoPagOnline === "pix") {
            const _usuario = {
              email: `pedido_${envio.numero_pedido}@gmail.com`,
              senha: "123",
              idloja: dadosApp.IdLoja,
            }
            await handleAutoLogin(_usuario);
          }

          toast.success('Pedido enviado com sucesso', { containerId: 'modalToast' });
          trackPurchase(envio);
          fechaModals();

          // APÓS ENVIAR O PEDIDO, VERIFICA SE ESTA CONFIGURADO PARA ENVIAR VIA WHATSAPP
          if (dadosApp.Empresa.Config.whatsapp === 1) {
            window.location.href = envio.whatsapp;
          }

          if (dadosApp.Empresa.Config.cartao_operadora === 'PAGSEGURO') {
            setDadosApp((prevState) => {
              return {
                ...prevState,
                GuidSessao: resp.data.guid,
              };
            });
          }
        } else {
          toast.error(resp.data.msg, { containerId: 'modalToast', autoClose: 20000, });
          if (isValidation) return false;
        }
      } else setModalLoading('none');
    },
    [
      closeModal,
      dados,
      setDadosApp,
      dadosApp,
      preparaDadosPedido,
      statusLoja,
      setStatusLoja,
      showHideModalLoading,
      fechaModals,
      handleIsCompleted,
      tabPagamentoActive,
      dadosCartao.empresa,
      user,
      handleAutoLogin,
      opcaoCartaoPagOnline
    ],
  );


  // SE FOR AUTO ATENDIMENTO BALCAO, VALIDA OS PRODUTOS
  const handleValidaProdutosBalcao = useCallback(async (e) => {
    if (tabPagamentoActive == 1) e?.preventDefault();

    setModalLoading('block');

    const envio = await preparaDadosPedido(dados, dadosApp.IdLoja, closeModal);

    let _qs = { ...dadosApp.Qs };

    _qs.Solicitacao = '8';
    _qs.Produtos = envio.Produtos
    _qs.Body = JSON.stringify(_qs);

    socketEmit(_qs);

    setModalLoading('none');
  }, [tabPagamentoActive, closeModal, dados, dadosApp, preparaDadosPedido, socketEmit]);


  // SE FOR AUTO ATENDIMENTO BALCAO, VALIDA OS PRODUTOS
  // const handleValidaProdutosBalcaoStripe = useCallback(async (e, isValidation = false, paydAsAppleOrGoogle = false, nsu = '') => {
  //   if (tabPagamentoActive == 1) e.preventDefault();

  //   if (isValidation) {
  //     handleValidaProdutosBalcao();
  //     return;
  //   }

  //   handleFinalizar(e, isValidation, paydAsAppleOrGoogle, nsu); // chama api pdv pelo socket

  // }, [tabPagamentoActive, handleValidaProdutosBalcao, handleFinalizar]);


  // const onValueChangeTipoPagOnline = (event) => {
  //   if (event) {
  //     setOpcaoCartaoPagOnline(event.target.value);
  //   }
  // };

  const handlePagSelecionado = (item) => {
    if (item.especie == 'ESPECIE') showHideModalTroco();
    else setTroco(0);

    setPagSelecionado(item);
  };

  const handleGetCartoes = useCallback(async (reload = false) => {
    if (!isGettingCards.current || reload) {
      isGettingCards.current = true;

      const card = {
        cartao_bandeira: "",
        cartao_codigo_seguranca: "",
        cartao_nome: "",
        cartao_numero: "",
        cartao_validade: "",
        cep: "",
        codigo_clente: 0,
        datahora: "",
        endereco: "",
        endereco_bairro: "",
        endereco_cidade: "",
        endereco_complemento: "",
        endereco_estado: "",
        endereco_numero: "",
        endereco_pais: "",
        excluido: 0,
        fantasia: "",
        id: 0,
        idloja: dadosApp.IdLoja,
        imagem: "",
        //metodo_pagamento: 0,
        nome: user.nome,
        nome_completo: user.nome_completo,
        nome_completo_cartao: user.nome_completo,
        razao: "",
        sobrenome: user.sobrenome,
        titular_documento_numero: "",
        titular_documento_tipo: "",
        titular_nome_completo: "",
        tokenCard: "",
        uf: "",
      }

      const cardPix = JSON.parse(JSON.stringify(card));
      cardPix.metodo_pagamento = 11; // ENUM (PagamentoOnlineOperacao)

      /*
        dadosApp.aceitaPagamentoSemUsuario:
        é uma configuração que determina se esta loja pode realizar pagamento do pix sem que o usuário se cadastre.
        caso seja permitido realizar pagamento sem se cadastrar, o sistema gerará um usuário padrão
        para poder seguir o fluxo e exibir a tela de pedidos do cliente.
      */

      // lógica original
      //const aceitaPix = dadosApp.Empresa.Config.pix_habilitado === 1 && !dadosApp.aceitaPagamentoSemUsuario && dadosApp.TipoApp === "DELIVERY";
      const aceitaPix = dadosApp.Empresa.Config.pix_habilitado === 1; //&& dadosApp.aceitaPagamentoSemUsuario;

      const options = aceitaPix ? [{
        option: "pix",
        text1: "Pix",
        text2: `Ao Finalizar o pedido, um código PIX será gerado. O Pagamento deve ser feito no aplicativo do seu banco. Depois, é só acompanhar a entrega pelo menu "Pedidos"`,
        card: cardPix,
      }] : [];

      if (dadosApp.Empresa.Config.pagamento_online === 1) {

        let temCartao = false;
        const resp = await GetCartoes(dadosCartao);
        if (resp.data.status == 'ok') {
          temCartao = resp.data.result?.length > 0;
          //setTemCartaoCadastrado(temCartao);

          if (temCartao) {
            resp.data.result[0].tokenCard = resp.data.result[0].cartao_numero;
            cartaoPreSelecionado.current = resp.data.result[0];
            cartaoPreSelecionado.current.metodo_pagamento = 0; // ENUM (PagamentoOnlineOperacao)
            //setPagOnlineSelecionado(resp.data.result[0]);
            //handleSetPagOnlineSelecionado(resp.data.result[0]);
          }

          resp.data.result?.forEach(element => {
            element.tokenCard = element.cartao_numero; // cria a propriedade do tokenCard, visto que não vem da api
            element.metodo_pagamento = 0; // ENUM (PagamentoOnlineOperacao)
            options.push({
              option: "cartao_cadastrado",
              text1: "Cartão Final **** " + element.cartao_nome,
              text2: "Expira em " + element.cartao_validade,
              card: element,
            })
          });
        }

        if (options.length > 0 && dadosApp.Empresa.Config.pagamento_online === 1) {
          //if (temCartao) {
          card.metodo_pagamento = 0; // ENUM (PagamentoOnlineOperacao)
          options.push({
            option: "novo_cartao",
            text1: options.length === 1 ? "Cartão de Crédito" : dadosApp.Empresa.Config.debito_habilitado === 1 ? "Novo Cartão de Crédito" : "Novo Cartão",
            text2: "Informar um novo cartão de crédito",
            card: card
          })
        }


        if (options.length === 0 && user.id > 0) setOpcaoCartaoPagOnline("novo_cartao");
      }

      if (dadosApp.Empresa.Config.debito_habilitado === 1) {
        const cardDebito = JSON.parse(JSON.stringify(card));
        cardDebito.metodo_pagamento = 12; // ENUM (PagamentoOnlineOperacao)
        options.push({
          option: "debito",
          text1: "Cartão de Débito",
          text2: "Pagar com cartão de débito",
          card: cardDebito
        })
      }

      setListOpcoesPagOnline(options);

    }
    setModalLoading("none") // correção bug estranho la pergoletta dia 27/12/2025 o loading não fechava ao entrar na tela de finalização
  }, [dadosCartao, dadosApp, user]);

  const handleIncludeTimes = useCallback(
    (_date) => {
      if (dadosApp.Empresa.Config.agendamento === 0) return;
      if (!entregaProgramada) return;

      const horariosDisponiveis = generateAvailableTimes(dadosApp.Empresa.Config, _date);

      setTime(horariosDisponiveis);
      if (horariosDisponiveis?.length > 0) setStartDate(horariosDisponiveis[0]);
    },
    [dadosApp, entregaProgramada],
  );

  const handleExcludeDates = useCallback(() => {
    if (dadosApp.Empresa.Config.agendamento === 0) return;
    if (!entregaProgramada) return;

    const _exclude = [];
    const config = dadosApp.Empresa.Config;
    const MAX_DIAS = config.agendamento_max_dias === 0 ? 180 : config.agendamento_max_dias;

    for (let index = 0; index < MAX_DIAS; index++) {
      const _date = addDays(new Date(), index);
      const dayOfWeek = getDay(_date);

      switch (dayOfWeek) {
        case 0: // domingo
          if (config.domingo === 0) _exclude.push(_date);
          break;

        case 1: // segunda
          if (config.segunda === 0) _exclude.push(_date);
          break;

        case 2: // terça
          if (config.terca === 0) _exclude.push(_date);
          break;

        case 3: // quarta
          if (config.quarta === 0) _exclude.push(_date);
          break;

        case 4: // quinta
          if (config.quinta === 0) _exclude.push(_date);
          break;

        case 5: // sexta
          if (config.sexta === 0) _exclude.push(_date);
          break;

        case 6: // sábado
          if (config.sabado === 0) _exclude.push(_date);
          break;

        default:
          break;
      }
    }

    setExclude(_exclude);
  }, [dadosApp, entregaProgramada]);

  const handleOnChangeCalendar = (date) => {
    const _isSameDay = isSameDay(startDate, date);

    if (_isSameDay) {
      setStartDate(date);
    } else {
      handleIncludeTimes(date);
    }
    //setStartDate(date);
  };

  // const HandleStripe = useCallback(() => {
  //   if (dadosApp.Empresa.Config.stripe === 1 && obj.total > 0) {
  //     return <Stripe value={obj.total} handleValidacao={handleFinalizar} setModalLoading={setModalLoading} />;
  //   }
  // }, [obj, dadosApp.Empresa.Config.stripe]);

  // ESCUTA OS EVENTOS DO SOCKET.IO
  const handleResposta = useCallback(
    (data) => {
      if (data) {

        //const msg = dadosApp.Qs.Modulo === 'CARTAO' ? 'Pagamento da Comanda ' : 'Pagamento da Mesa ';
        const msg = dadosApp.Qs.Portaria === "true" ? 'Pagamento da Comanda ' + dadosApp.Qs.comanda : dadosApp.Qs.Modulo === 'CARTAO' ? 'Pagamento da Comanda ' + dadosApp.Qs.comanda : 'Pagamento da Mesa ' + dadosApp.Mesa;
        switch (data.Solicitacao) {
          case '0': // STATUS_MESA - GETDADOS
          case '1': // STATUS_MESA - GETDADOS
          case '2': // CONFERENCIA
          case '3': // PAGAMENTO
            //case '4': // STATUS_AUTO_ATENDIMENTO
            break;

          case '5': // BAIXA AUTO ATENDIMENTO
            setModalLoading('none');
            dadosApp.Qs.comanda = 0; // zera o numero da comanda apos a baixa
            if (data.readed) return;

            if (data.Status === 0) {
              ClearPedido(dadosApp.IdLoja, setSacola);

              navigate('/loja/PageSuccess?msg=' + msg + ' Realizado com Sucesso!', {
                replace: true,
              });
            } else {
              try {
                const _dados = JSON.parse(data.Body);
                navigate(
                  '/loja/Page404?message=' + // eslint-disable-next-line prettier/prettier
                  msg + // eslint-disable-next-line prettier/prettier
                  ' foi Realizado com Sucesso!  \n\n' + // eslint-disable-next-line prettier/prettier
                  _dados.msg, // eslint-disable-next-line prettier/prettier
                  { replace: true },
                );
              } catch (error) {
                navigate(
                  '/loja/Page404?message=' + // eslint-disable-next-line prettier/prettier
                  msg + // eslint-disable-next-line prettier/prettier
                  ' foi Realizado com Sucesso!  \n\n' + // eslint-disable-next-line prettier/prettier
                  data.Body, // eslint-disable-next-line prettier/prettier
                  { replace: true },
                );
              }
            }
            break;

          case '8':
            if (data.readed) return;
            if (data.Status !== 0) {
              closeModal();
              toast.error(data.Body, { containerId: 'modalToast' });
            }
            return;

          default:
            navigate('/loja/Page404?message=Solicitação Não Homologada', { replace: true });
            break;
        }
      } else {
        navigate('/loja/Page404?message=Erro ao obter resposta', { replace: true });
      }
      data.readed = true;
    },
    [navigate, dadosApp, setSacola, closeModal],
  );


  const RenderStripe = React.useCallback(() => {
    const canRenderStripe =
      obj.total > 0 &&
      dadosApp.Empresa.Config.stripe_token_secreto?.length > 0;

    if (!canRenderStripe) return null;

    // if (obj.total <= 0 && dadosApp.Empresa.Config.stripe_token_secreto === '') return;

    return (
      <Stripe
        value={obj.total}
        handleValidacao={
          param.conferencia
            ? handlePagarAutoAtendimento
            : handleFinalizar
        }
        setModalLoading={setModalLoading}
      />
    );

  }, [obj.total]);


  useEffect(() => {
    if (!isObjectEmpty(socketResponse)) {
      handleResposta(socketResponse);
    }
    //return () => socketResponse;
  }, [socketResponse, handleResposta]);


  useEffect(() => {
    if (dadosApp.Qs.Modulo === 'BALCAO') handleValidaProdutosBalcao();
  }, [dadosApp.Qs.Modulo]);


  useEffect(() => {
    if (tabPagamentoActive === 0 && cartaoValidado) {
      if (param.conferencia) handlePagarAutoAtendimento(); // se for pagamento de mesa/cartao via conferencia
      //else if (dadosApp.Qs.Modulo === 'BALCAO') handleValidaProdutosBalcao(); // se for pagamento balcao
      else {
        handleFinalizar();
      }
      setCartaoValidado(false);
    }
  }, [
    tabPagamentoActive,
    cartaoValidado,
    param.conferencia,
    handleFinalizar,
    dadosApp.Qs.Modulo,
    handlePagarAutoAtendimento,
    handleValidaProdutosBalcao,
  ]);

  useEffect(() => {
    handleIncludeTimes(statusLoja.NextValidDay); // new Date()
  }, [handleIncludeTimes, statusLoja.NextValidDay]);

  useEffect(() => {
    handleExcludeDates();
  }, [handleExcludeDates]);

  useEffect(() => {
    handleIsCompleted();
  }, [handleIsCompleted]);

  useEffect(() => {
    if (user.id === 0) handleGetCartoes();
    else handleGetCartoes(dadosApp.aceitaPagamentoSemUsuario);
  }, [handleGetCartoes, dadosApp.aceitaPagamentoSemUsuario, user.id]);

  // useEffect(() => {
  //   if (tabPagamentoActive == 0 && cartoes.length == 0 && firstLoad) {
  //     handleGetCartoes();
  //     setModalLoading('none');
  //     setFirstLoad(false);
  //   }
  // }, [tabPagamentoActive, handleGetCartoes, cartoes, firstLoad]);

  return (
    <div style={{ background: "#FFF" }}>
      <div>
        {dadosApp.TipoApp === 'DELIVERY' && (
          <>
            <div style={{ position: 'sticky', top: '-1px', zIndex: '99', background: 'white' }}>
              <Tabs
                text1={dadosApp.IdLoja === 9130 ? '' : dadosApp.IdLoja === 1910 ? '' : 'Entrega'} // cliente do sergio
                text2={dadosApp.Empresa.Config.pagamento_retirar == 1 ? 'Retirar' : ''}
                active={tabEntregaActive}
                setTabActive={setTabEntregaActive}
              />
            </div>

            <div className="container padTop20" style={{ paddingBottom: '30px', minHeight: '172px' }}>
              {tabEntregaActive == 0 && (
                <div style={{ margin: '0 5px' }}>
                  <span>Endereço de Entrega: </span>
                  {/* <Button
                    text={!isObjectEmpty(enderecoEntrega) ? enderecoConcatenado() : 'Selecionar Endereço'}
                    onClick={showHideModalEnderecos}
                    icon={isObjectEmpty(enderecoEntrega) ? 'keyboard_arrow_right' : ''}
                    iconAlign="right"
                    className="btnWhite btn-shadow"
                  /> */}

                  <div
                    className="btnWhite btn-shadow-active"
                    style={{ margin: '15px 0 30px 0', width: '100%', marginLeft: '0', height: "100%", }}
                    onClick={showHideModalEnderecos}
                  >
                    <i className="material-icons  btnIconAlignRight" style={{ marginTop: 15 }}>
                      keyboard_arrow_right
                    </i>
                    <div className='content-centered' style={{ color: isObjectEmpty(enderecoEntrega) ? "rgb(229,71,80)" : "" }}>
                      <p>{!isObjectEmpty(enderecoEntrega) ? enderecoConcatenado() : 'Selecionar Endereço'}</p>
                    </div>
                  </div>

                  <span>
                    Previsão de Entrega: {'  '}
                    {dadosApp.Empresa.Config.previsao_entrega} min {'  '}
                  </span>

                  {/* <span>{format(addMinutes(new Date(), dadosApp.Empresa.Config.previsao_entrega), 'HH:mm')}</span> */}
                </div>
              )}
              {tabEntregaActive == 1 && dadosApp.Empresa.Config.pagamento_retirar == 1 && (
                <div style={{ margin: '0 5px' }}>
                  <span>Nosso Endereço: </span>
                  <p style={{ textTransform: 'capitalize', marginTop: '10px' }}>
                    {'cep: ' + dadosApp.Empresa.Empresa.cep}
                  </p>
                  <p style={{ textTransform: 'capitalize', marginTop: '5px' }}>
                    {dadosApp.Empresa.Empresa.endereco +
                      ', ' +
                      dadosApp.Empresa.Empresa.endereco_numero +
                      ', ' +
                      dadosApp.Empresa.Empresa.endereco_bairro +
                      ', ' +
                      dadosApp.Empresa.Empresa.endereco_cidade}
                  </p>
                </div>
              )}

              {dadosApp.Empresa.Config.agendamento === 1 && (
                <div
                  //className="btn-shadow"
                  style={{
                    //backgroundColor: entregaProgramada ? '#f9f9f9' : '#FFF',
                    padding: 10,
                    borderRadius: 10,
                    margin: '20px 5px 0 5px',
                    border: '1px solid #ebebeb',
                    //boxShadow: entregaProgramada ? 'inset 0px 0px 26px -6px rgb(10 10 10 / 23%)' : 'none',
                  }}
                >
                  <div className={'checkboxes'} style={{ margin: '10px 0 0 5px' }}>
                    <label className={'container-check'} style={{ color: 'rgb(0, 55, 107)' }}>
                      {`${tabEntregaActive === 0 ? 'Agendar a entrega ' : 'Agendar a retirada '}`}
                      <input
                        type={'checkbox'}
                        defaultChecked={entregaProgramada}
                        value={entregaProgramada}
                        name={'name'}
                        //disabled={statusLoja.StatusLoja === false}
                        disabled={statusLoja.StatusLoja === false ? true : dadosApp.IdLoja === 9130 ? true : dadosApp.IdLoja === 1910 ? true : false}
                        onChange={() => setEntregaProgramada(!entregaProgramada)}
                      />
                      <span className={'checkmark'}></span>
                    </label>
                  </div>

                  {entregaProgramada && (
                    <div
                      className="btnWhite btn-shadow-active"
                      style={{ margin: '30px 0 10px 0', width: '95%', marginLeft: '2.5%' }}
                    >
                      <i className="material-icons  btnIconAlignRight" style={{ marginTop: 15 }}>
                        keyboard_arrow_right
                      </i>
                      <DatePicker
                        locale="pt-BR"
                        dateFormat="d MMMM yyyy  HH:mm"
                        minDate={statusLoja.NextValidDay} //new Date()
                        maxDate={addDays(
                          statusLoja.NextValidDay, // new Date()
                          dadosApp.Empresa.Config.agendamento_max_dias === 0
                            ? 180
                            : dadosApp.Empresa.Config.agendamento_max_dias - 1,
                        )}
                        excludeDates={exclude}
                        selected={startDate}
                        onChange={handleOnChangeCalendar}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        timeCaption="Hora"
                        includeTimes={time}
                        //showDisabledMonthNavigation
                        //readOnly
                        //disabled
                        withPortal
                      >
                        {/* <div style={{ color: 'red' }}>Dont forget to check the weather!</div> */}
                      </DatePicker>
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        )}

        <div style={{ position: 'sticky', top: '-1px', zIndex: '99', background: 'white' }}>
          <Tabs
            text1={hasPagamentoDisponivel ? "Pagar Agora" : ''
              // dadosApp.Empresa.Config.pagamento_online === 1 ? 'Pagar Agora'
              //   : dadosApp.Empresa.Config.stripe_token_secreto?.length > 0 ? 'Pagar Agora'
              //     : dadosApp.Empresa.Config.debito_habilitado === 1 ? 'Pagar Agora'
              //       : dadosApp.Empresa.Config.pix_habilitado === 1 ? "Pagar Agora" : ''
            }
            text2={dadosApp.Empresa.Config.pagamento_portador === 1 && dadosApp.FormasPagamento?.length > 0 ? pagEntregaText : ''}
            active={tabPagamentoActive}
            setTabActive={setTabPagamentoActive}
          />
        </div>
        <div className="container">
          <div style={{ margin: '0 5px' }}>
            <ValoresTotais
              subtotal={obj.subtotal}
              desconto={obj.desconto}
              acrescimo={obj.acrescimo}
              taxa={obj.taxa}
              total={obj.total}
              isDelivery={dadosApp.TipoApp === 'DELIVERY'}
            />
          </div>

          {tabPagamentoActive === 0 && (
            <div
              style={{
                margin: '0 -20px ',
              }}
            >

              <RenderStripe />

              <div
                style={{
                  margin: '0 0px 15px',
                  border: '1px solid rgb(235, 235, 235)',
                  borderBottom: 'none',
                  borderRadius: 3
                }}
              >

                <CardSelectOptions
                  data={listOpcoesPagOnline}
                  setOptionSelected={setOpcaoCartaoPagOnline}
                  setPagOnlineSelecionado={setPagOnlineSelecionado} />

                {/* {opcaoCartaoPagOnline === "pix" && user.cpf === "" && ( */}
                {tabPagamentoActive === 0 && user.cpf === "" && !dadosApp.aceitaPagamentoSemUsuario && (
                  <div style={{ margin: 20 }}>
                    <div style={{ color: "rgb(229, 71, 80)", marginBottom: -20, marginLeft: 10 }}>
                      {user.id === 0 ? "Para pagar com PIX é necessário se cadastrar" : "Complete seu Cadastro:"}
                    </div>
                    <div
                      className="btnWhite btn-shadow-active"
                      style={{ margin: '30px 0 10px 0', width: '95%', marginLeft: '2.5%' }}
                      onClick={() => {
                        if (user.id === 0) setModalLogin(true)
                        else setModalCadastro(true)
                      }}
                    >
                      <i className="material-icons  btnIconAlignRight" style={{ marginTop: 15 }}>
                        keyboard_arrow_right
                      </i>
                      <div style={{ margin: "16px 0 16px 20px", float: "left", color: user.id > 0 ? "rgb(229,71,80)" : "" }}>
                        {user.id === 0 || user.email.includes("pedido_") && dadosApp.aceitaPagamentoSemUsuario ? "Cadastro/login" : "* CPF Inválido"}
                      </div>
                      <div style={{ margin: "16px 45px 16px 20px", float: "right" }}>
                        {user.id === 0 ? "" : "Corrigir"}
                      </div>
                    </div>
                  </div>
                )}

                {showCadastreSe && (
                  <div style={{ margin: 20 }}>
                    <div style={{ color: "rgb(229, 71, 80)", marginBottom: -20, marginLeft: 10 }}>
                      Para pagar com Cartão é necessário se cadastrar
                    </div>
                    <div
                      className="btnWhite btn-shadow-active"
                      style={{ margin: '30px 0 10px 0', width: '95%', marginLeft: '2.5%' }}
                      //onClick={() => setModalCadastro(true)}
                      onClick={() => {
                        //handleFinalizar(undefined, false, true, "123") // para testes
                        if (user.id === 0 || user.email.includes("pedido_") && dadosApp.aceitaPagamentoSemUsuario) setModalLogin(true)
                        else setModalCadastro(true)
                      }}
                    >
                      <i className="material-icons  btnIconAlignRight" style={{ marginTop: 15 }}>
                        keyboard_arrow_right
                      </i>
                      <div style={{ margin: "16px 0 16px 20px", float: "left", color: user.id > 0 ? "rgb(229,71,80)" : "" }}>
                        {user.id === 0 || user.email.includes("pedido_") && dadosApp.aceitaPagamentoSemUsuario ? "Cadastro/login" : "* CPF Inválido"}
                      </div>
                      <div style={{ margin: "16px 45px 16px 20px", float: "right" }}>
                        {user.id === 0 ? "" : "Corrigir"}
                      </div>
                    </div>
                  </div>
                )}


                {/* {(opcaoCartaoPagOnline !== 'novo_cartao' && opcaoCartaoPagOnline !== "" && user.id > 0) || (opcaoCartaoPagOnline === "pix" && !dadosApp.aceitaPagamentoSemUsuario) && ( */}
                {showButtonFinalizar && (
                  <>
                    <div style={{ margin: 30 }}>
                      <div style={{ margin: '-15px' }}>
                        <FinalizacaoRodape
                          onClick={param.conferencia ? handlePagarAutoAtendimento : handleFinalizar}
                          // : dadosApp.Qs.Modulo === 'BALCAO'
                          //   ? handleValidaProdutosBalcao : handleFinalizar}
                          isPagOnline={tabPagamentoActive === 0}
                          isCompleted={isCompleted}
                          valor={obj.total}
                        />
                      </div>
                    </div>

                    <GatewaysLogo isPix={opcaoCartaoPagOnline?.toUpperCase() === "PIX"} />

                  </>
                )}

                {showFormCartao && user.cpf !== "" && (
                  <div style={{ margin: 20 }}>
                    <CadastroCartoes
                      formDireto
                      onClick={handleCartaoValidado}
                      setDadosCartao={setPagOnlineSelecionado}
                      valor={obj.total}
                    />
                  </div>
                )}

              </div>
            </div>
          )}
          {tabPagamentoActive === 1 && (
            <div
              style={{
                borderTop: '1px solid #ebebeb',
                margin: '0 5px',
                // margin: '-20px 5px',
                paddingTop: '10px',
              }}
            >
              <FormasPagamento troco={troco} onSelect={handlePagSelecionado} itemSelected={pagSelecionado} />
            </div>
          )}
        </div>

        {modalCartoes === 'block' && (
          <Modal
            title="Cartões"
            isFooter={false}
            visibility={modalCartoes}
            param={{
              isFinalizacao: true,
              setPagOnlineSelecionado: setPagOnlineSelecionado,
              closeModal: showHideModalCartoes,
            }}
            page="LISTA_CARTOES"
            btnOnClickClose={showHideModalCartoes}
          />
        )}
        {modalEnderecos === 'block' && (
          <Modal
            title="Endereços"
            isFooter={false}
            visibility={modalEnderecos}
            param={{
              isFinalizacao: true,
              isFatura: false,
              setEnderecoEntrega: setEnderecoEntrega,
              closeModal: showHideModalEnderecos,
            }}
            page="ENDERECOS"
            btnOnClickClose={showHideModalEnderecos}
          />
        )}
        {modalCadastro && (
          <Modal
            title="Meus Dados"
            isFooter={false}
            visibility={modalCadastro ? "block" : "none"}
            page="MEUS_DADOS"
            btnOnClickClose={() => setModalCadastro(!modalCadastro)}
          />
        )}
        {modalLogin && (
          <Modal
            title="Login"
            isFooter={false}
            visibility={modalLogin ? "block" : "none"}
            page="LOGIN"
            btnOnClickClose={() => setModalLogin(!modalLogin)}
          />
        )}
        {modalLoading === 'block' && (
          <Modal
            title=""
            isFooter={false}
            visibility={modalLoading}
            param={{ msg: 'Aguarde...' }}
            page="LOADING"
            customPosition="loading-modal"
          />
        )}
        {modalTroco === 'block' && (
          <Modal
            title="Precisa de Troco ?"
            isFooter={false}
            visibility={modalTroco}
            param={{ troco: troco, setTroco: setTroco, showHideModalTroco: showHideModalTroco, total: obj.total }}
            page="FINALIZACAO_TROCO"
            btnOnClickClose={showHideModalTroco}
            customPosition="modal-position-bottom"
          />
        )}
      </div>


      {
        tabPagamentoActive === 1 && (
          <div style={{ margin: '20px 5px 0' }}>
            <FinalizacaoRodape
              onClick={param.conferencia ? handlePagarAutoAtendimento : handleFinalizar}
              // : dadosApp.Qs.Modulo === 'BALCAO'
              // ? handleValidaProdutosBalcao : handleFinalizar}
              isPagOnline={tabPagamentoActive == 0}
              isCompleted={isCompleted}
              valor={obj.total}
            />
          </div>
        )
      }
      {/* )} */}
    </div >
  );
};

Finalizacao.propTypes = {
  closeModal: P.func.isRequired,
  param: P.object,
};
